export default __webpack_public_path__ + "static/media/Unverified.3545ff52.svg";